import React from 'react';

const NodeResourceBar = ({ label, value, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary-500',
    green: 'bg-green-500',
    purple: 'bg-purple-500',
    red: 'bg-red-500',
    yellow: 'bg-yellow-500'
  };

  const iconMap = {
    CPU: 'w-3 h-3 mr-1',
    Memory: 'w-3 h-3 mr-1',
    Disk: 'w-3 h-3 mr-1'
  };

  return (
    <div>
      <div className="flex justify-between text-xs mb-1">
        <span className="text-gray-600 dark:text-dark-400 flex items-center">
          {label}
        </span>
        <span className="text-gray-900 dark:text-white">{(value || 0).toFixed(1)}%</span>
      </div>
      <div className="w-full bg-gray-200 dark:bg-dark-800 rounded-full h-1.5">
        <div 
          className={`${colorClasses[color] || colorClasses.primary} h-1.5 rounded-full transition-all duration-300`}
          style={{ width: `${Math.min(Math.max(value || 0, 0), 100)}%` }}
        ></div>
      </div>
    </div>
  );
};

export default NodeResourceBar;